import { css } from 'styled-components';
var disabledCss = /*#__PURE__*/css(["opacity:0.4;cursor:not-allowed;&:hover,&:active{transform:none;}"]);
/**
 * Миксин неактивной кнопки
 */

export var applyDisabled = function applyDisabled(_ref) {
  var disabled = _ref.disabled,
      $disabled = _ref.$disabled;
  return css(["&:disabled{", "}", ""], disabledCss, (disabled || $disabled) && disabledCss);
};